export default {
  state: {
    avatar: {
      min: 50,
      max: 150,
      roundness: [{ key: 'round', value: 100 }, { key: 'square', value: 0 }, { key: 'roundedCorners', value: 5 }]
    },
    font: {
      size: [{ key: 'small', value: 11 }, { key: 'medium', value: 12 }, { key: 'large', value: 13 }],
      family: [
        {
          label: 'sans-serif',
          options: [
            { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
            { label: 'Comic Sans MS', value: "'Comic Sans MS', sans-serif" },
            { label: 'Lucida Grande', value: "'Lucida Grande', sans-serif" },
            { label: 'Tahoma', value: 'Tahoma, sans-serif' },
            { label: 'Trebuchet MS', value: "'Trebuchet MS', sans-serif" },
            { label: 'Verdana', value: 'Verdana, sans-serif' }
          ]
        },
        {
          label: 'monospace',
          options: [
            {
              label: 'Courier New',
              value: '"Courier New", Courier, monospace'
            },
            { label: 'Comic Sans MS', value: '"Comic Sans MS", sans-serif' },
            {
              label: 'Lucida Console',
              value: '"Lucida Console", Monaco, monospace'
            }
          ]
        }
      ]
    },
    separator: {
      options: [{ key: 'slash', value: '/' }, { key: 'divide', value: '|' }, { key: 'at', value: 'at' }, { key: 'newLine', value: 'br' }]
    },
    types: [{ key: 'text', value: 'text' }, { key: 'email', value: 'email' }, { key: 'link', value: 'link' }]
  },
  getters: {},
  mutations: {},
  actions: {}
};
